var SocialShare = {};

//--------------
// Variables
//--------------
SocialShare.titleFacebook = 'Partager sur Facebook';
SocialShare.titleTwitter = 'Partager sur Twitter';
SocialShare.titleLinkedIn = 'Partager sur LinkedIn';
SocialShare.titleGoogle = 'Partager sur Google+';

SocialShare.title = '';
SocialShare.text = '';
SocialShare.url = '';

SocialShare.winHeight = 600;
SocialShare.winWidth = 550;
SocialShare.winTop = (screen.height / 2) - (SocialShare.winHeight / 2);
SocialShare.winLeft = (screen.width / 2) - (SocialShare.winWidth / 2);

SocialShare.windowParam = 'top=' + SocialShare.winTop + ',left=' + SocialShare.winLeft + ',toolbar=0,status=0,width=' + SocialShare.winWidth + ',height=' + SocialShare.winHeight;


//--------------
// Functions
//--------------

/**
 * Facebook share
 * @return {void}
 */
SocialShare.shareFacebook = function() {
  window.open('http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(SocialShare.url),
    SocialShare.titleFacebook, SocialShare.windowParam);
}

/**
 * Twitter share
 * @return {void}
 */
SocialShare.shareTwitter = function() {
  window.open('http://twitter.com/share?url=' +
    encodeURIComponent(SocialShare.url) + '&text=' +
    encodeURIComponent(SocialShare.title) + '&count=none/',
    SocialShare.titleTwitter, SocialShare.windowParam);
}

/**
 * LinkedIn share
 * @return {void}
 */
SocialShare.shareLinkedIn = function() {
  window.open('https://www.linkedin.com/cws/share?url=' +
    encodeURIComponent(SocialShare.url), SocialShare.titleLinkedIn, SocialShare.windowParam);
}

/**
 * Google share
 * @return {void}
 */
SocialShare.shareGoogle = function() {
  window.open('https://plus.google.com/share?url=' +
    encodeURIComponent(SocialShare.url), SocialShare.titleGoogle, SocialShare.windowParam);
}

/**
 * Email share
 * @return {void}
 */
SocialShare.shareEmail = function() {
  window.location = 'mailto:?subject=' + SocialShare.title + '&body=' + SocialShare.url  + ' ' + SocialShare.text;
}


/**
 * Init Service Banner scripts
 * @return {[type]} [description]
 */
SocialShare.init = function() {
	SocialShare.$shareButton = $('.js-share-button');

	if (SocialShare.$shareButton.titleFacebook) SocialShare.titleFacebook = SocialShare.$shareButton.titleFacebook;
	if (SocialShare.$shareButton.titleTwitter) SocialShare.titleTwitter = SocialShare.$shareButton.titleTwitter;
	if (SocialShare.$shareButton.titleLinkedIn) SocialShare.titleLinkedIn = SocialShare.$shareButton.titleLinkedIn;
	if (SocialShare.$shareButton.titleGoogle) SocialShare.titleGoogle = SocialShare.$shareButton.titleGoogle;

	SocialShare.url = window.location.href;
	SocialShare.title = $('title:first').text();
	SocialShare.text = $('[property="og:description"]').attr('content') || '';

	SocialShare.$shareButton.click(function(e) {
      var $this = $(this);

      // Inside list of items
      if ($this.attr('data-url')) {
        SocialShare.url = $this.attr('data-url');
      }
      if ($this.attr('data-title')) {
        SocialShare.title = $this.attr('data-title');
      }
      if ($this.attr('data-text')) {
        SocialShare.text = $this.attr('data-text');
      }

      // Single item
      if ($this.attr('data-type') === 'facebook') {
        SocialShare.shareFacebook();
      } else if ($this.attr('data-type') === 'twitter') {
        SocialShare.shareTwitter();
      } else if ($this.attr('data-type') === 'linkedin') {
        SocialShare.shareLinkedIn();
      } else if ($this.attr('data-type') === 'google') {
        SocialShare.shareGoogle();
      } else if ($this.attr('data-type') === 'email') {
        SocialShare.shareEmail();
      }
	});
}

/**
 * Destroy Service Banner scripts
 * @return {void}
 */
SocialShare.destroy = function() {

}

module.exports = SocialShare;